export default __webpack_public_path__ + "static/media/Om.9e6771f1.png";